import React from 'react'
import { BaseDrawer } from '@/components/drawer/base-drawer'
import { Expaned, Column, Row } from '@/components/layout/layout'
import { getBEMCls } from '@/utils/classname'
import './goods-change-record.scss'
import { UserInfo } from '@/components/user-info/user-info'
import classNames from 'classnames'
import { Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { layerManage, showLayer } from '@/utils/layer'
import { useRequest } from 'ahooks'
import { $post } from '@/api'
import { IPagination } from '@/model/types/common'
import { AutoResizer, WithScrollLoad } from '@/utils/utils-widget'
import { BaseDialog } from '@/components/dialog/base-dialog'
import { IUser } from '@/model/types/user'

interface RecordItem {
    approve_status: number | null
    create_time: string
    goods_name: string
    operate_detail: string
    operate_type: number
    refuse_reason: string | null
    staff: {
        id: number
        user: IUser
    }
}

interface RecordList {
    list: RecordItem[]
    pagination: IPagination
}

interface IProps {
    record: RecordItem
}

const cls = (...args: string[]) => getBEMCls('goodsChangeRecord', ...args)

const RecordDetail: React.FC<IProps> = props => {
    return (
        <BaseDialog
            isShow
            title="操作详情"
            onClose={() => {
                layerManage.pop()
            }}
        >
            <div className={cls('goodsContent')}>
                <Row className={cls('goodsTitle')}>
                    <div data-font-size-16 data-font-weight-600>
                        {props.record.goods_name}
                    </div>
                </Row>
                <Row className={cls('operate')}>
                    <Expaned className={cls('operateContent')}>
                        <Row className={cls('item')}>
                            <div className={cls('item', 'title')}>操作人</div>
                            <div className={cls('item', 'content')} data-overflow-hidden>
                                <UserInfo userInfo={props.record.staff.user}></UserInfo>
                            </div>
                        </Row>
                        <Row className={cls('item')}>
                            <div className={cls('item', 'title')}>操作内容</div>
                            <div className={cls('item', 'content')}>
                                {props.record.operate_type === 18 && <span>添加商品</span>}
                                {props.record.operate_type === 19 && <span>新建商品</span>}
                                {props.record.operate_type === 20 && <span>删除商品</span>}
                                {props.record.operate_type === 21 && <span>修改商品</span>}
                            </div>
                        </Row>
                        <Row className={cls('item')}>
                            <div className={cls('item', 'title')}>操作详情</div>
                            <div className={cls('item', 'content')}>{props.record.operate_detail}</div>
                        </Row>
                    </Expaned>
                    <Expaned className={cls('operateContent')} data-margin-left-20>
                        <Row className={cls('item')}>
                            <div className={cls('item', 'title')}>操作时间</div>
                            <div className={cls('item', 'content')}>{props.record.create_time}</div>
                        </Row>
                        {props.record.operate_type === 19 && (
                            <Row className={cls('item')}>
                                <div className={cls('item', 'title')}>操作状态</div>
                                {![-2, -3].includes(props.record.approve_status as number) && (
                                    <span className={classNames(cls('item', 'content'), 'them-color')}>已通过</span>
                                )}
                                {props.record.approve_status === -2 && (
                                    <span className={classNames(cls('item', 'content'), 'them-color')}>审核中</span>
                                )}
                                {props.record.approve_status === -3 && (
                                    <span className={classNames(cls('item', 'content'), cls('danger'))}>已拒绝</span>
                                )}
                            </Row>
                        )}
                        {props.record.approve_status === -3 && (
                            <Row className={cls('item')}>
                                <div className={cls('item', 'title')}>拒绝理由</div>
                                <div className={classNames(cls('item', 'content'), cls('danger'))}>
                                    {props.record.refuse_reason}
                                </div>
                            </Row>
                        )}
                    </Expaned>
                </Row>
            </div>
        </BaseDialog>
    )
}

export const GoodsChangeRecord = () => {
    const columns: ColumnsType<RecordItem> = [
        {
            title: '时间',
            key: 'create_time',
            width: 140,
            dataIndex: 'create_time',
        },
        {
            title: '商品',
            key: 'goods_name',
            ellipsis: true,
            dataIndex: 'goods_name',
        },
        {
            title: '操作人',
            key: 'staff',
            dataIndex: 'staff',
            ellipsis: true,
            render: val => (
                <Row data-align-items-center>
                    <img src={val.user.avatar} alt="" className={cls('user-avatar')} />
                    {val.user.realname || val.user.nickname}
                </Row>
            ),
        },
        {
            title: '操作内容',
            key: 'operate_detail',
            dataIndex: 'operate_detail',
            align: 'right',
            render: (val, record) => (
                <div
                    className="text-btn-blue"
                    onClick={() => {
                        showLayer(<RecordDetail record={record} />)
                    }}
                >
                    {val}
                </div>
            ),
        },
    ]

    const requestHandle = useRequest<
        RecordList,
        {
            records_list: RecordItem[]
            pagination: IPagination
        }
    >(
        val => {
            return $post({
                url: '/staff/getstaffgoodsoperaterecordlist',
                params: {
                    limit: 20,
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                },
            })
        },
        {
            isNoMore: data => {
                if (data?.pagination) {
                    return data?.pagination.page === data?.pagination.page_count
                } else {
                    return false
                }
            },
            loadMore: true,
            formatResult: data => {
                return {
                    list: data.records_list,
                    pagination: data.pagination,
                }
            },
        },
    )

    const { loading, data } = requestHandle

    return (
        <BaseDrawer
            isShow
            width={700}
            title="商品变更记录"
            onClose={() => {
                layerManage.pop()
            }}
        >
            <Column data-margin-16 className={cls()}>
                <AutoResizer>
                    {({ height }) => {
                        return (
                            <WithScrollLoad data-expaned data-overflow-hidden scrollloadhandle={requestHandle}>
                                <Table
                                    rowKey={record => record.create_time}
                                    loading={loading}
                                    bordered
                                    pagination={false}
                                    columns={columns}
                                    dataSource={data?.list}
                                    scroll={{ x: 'max-content', y: height - 50 }}
                                />
                            </WithScrollLoad>
                        )
                    }}
                </AutoResizer>
            </Column>
        </BaseDrawer>
    )
}
